import OrderInformationHeaders from "./SingleAudiobookInformationHeaders";
import OrderInformationNonEditable from "./SingleAudiobookInformationNonEditable";
import { useEffect } from "react";

const OrderInformation = ({ order }) => {
  useEffect(() => {

  }, [order]);
  let netAmount = order.totalAmount - order.taxAmount;
  return (
    <div
      className="container"
      style={{ textAlign: "center", maxWidth: "100%", }}
    >
      <table width="100%">
        <tr>
          <td>
            <div style={{
              textAlign: "left",
              fontSize: "3vh",
              position: "relative",
              top: "2vh",
            }}>
              Szczegóły zamówienia
            </div>
            <p />
          </td>
        </tr>
        <tr>
          <td colSpan={2}>
            <div style={{
              fontSize: "3vh",
              backgroundColor: "#eee",
              position: "relative",
              top: "0.5vh",
              boxShadow: "4px 4px 3px 0px rgba(0,0,0,0.2)",
            }}>
              Faktura:
              {order?.orderNumber && (
                <span style={{ marginLeft: "1em", fontWeight: "normal" }}>
                  <b>{order.orderNumber}</b>
                </span>

              )}
              <span style={{ marginLeft: "1em", fontWeight: "normal" }}>
                {order?.orderDate ? " z dnia " + new Date(order.orderDate).toLocaleDateString() : ""}
              </span>
            </div>
          </td>
        </tr>
      </table>
      <div style={{
        fontSize: "2vh",
        position: "relative",
        top: "1.5vh",
      }}>
        <table>
          <tr>
            <td className="col-sm-2"> <b>Ilość pozycji</b></td>
            <td className="col-sm-2"><b>Wartość netto</b></td>
            <td className="col-sm-2"><b>Kwota vat</b></td>
            <td className="col-sm-2"><b>Wartość brutto</b></td>
          </tr>
          <tr>
            <td className="col-sm-2" style={{}}>{order.items.length}</td>
            <td className="col-sm-2" style={{}}>{netAmount / 100} zł</td>
            <td className="col-sm-2" style={{}}>{order.taxAmount / 100} zł</td>
            <td className="col-sm-2" style={{}}>{order.totalAmount / 100} zł</td>
          </tr>
        </table>
      </div>
    </div >
  );
};

export default OrderInformation;
